import React, { Component } from 'react'
import Grid from "../../components/grid";
import { connect } from "react-redux";
import Plus_icon from '../../assets/images/plus_icon.png'
import './style.scss';
import { getContractHours, saveContractHours, GetEins, getChildCCByTreeIndex, getAdminSettings } from '../../store/actions';
import { startOfDay, subDays, subMonths } from 'date-fns';
import { has, sortBy } from 'lodash';
import FileUpload from '../../components/file-upload';
import { read, utils } from 'xlsx';

class PPDContHoursView extends Component {
    state = {
        einList: [],
        pinnedTopRowData: [{
            date: ""
        }],
        contractHoursData: [],
        columnDefs: [],
        showFileUpload: false,
        src: null,
        file: null,
        fileConvertError: false,
        uploadFileName: null,
        dragging: false,
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
    };

    getContractHrs = async payload => {
        await this.props.getContractHours(this.props.UserReducer.company, payload);
    };

    loadMore = async () => {
        let { startDate } = this.state;
        let dateFrom = Date.parse(startOfDay(subDays(startDate, 31)));
        let dateTo = Date.parse(startOfDay(subDays(startDate, 1)));
        await this.getContractHrs({ startDate: dateFrom, endDate: dateTo });
        let { rowData } = this.state;
        let moreData = sortBy([...this.props.PPD_CONTRACT_HOURS, ...rowData], ["date", "jobName"]);
        this.setState({ rowData: moreData, startDate: dateFrom });
    };

    onCellValueChange = async props => {
        let { data, oldValue, value } = props;
        let { companyShortName, date, EINName, hours, jobName } = data;
        let { isMultiEIN } = this.state;
        let contractHours = {
            date: Date.parse(startOfDay(date)),
            companyShortName: companyShortName || this.props.UserReducer.company,
            hours,
            jobName
        };
        if (isMultiEIN) contractHours.EINName = EINName;
        if (jobName && hours && date && (!isMultiEIN || isMultiEIN && EINName)) {
            if (value && value !== oldValue) {
                this.gridApi.applyTransaction({ add: [{ date: startOfDay(new Date) }] });
            }
            this.props.saveContractHours(contractHours);
        };
        return;
    };

    onFirstDataRender = props => {
        let lastIndex = this.state.rowData && this.state.rowData.length > 0 ? this.state.rowData.length - 1 : 0;
        this.gridApi.ensureIndexVisible(lastIndex, "bottom");
    };

    saveRecords = (records) => {
        this.props.saveContractHours(records);
    };

    addContractRecs = () => {
        this.setState({ showFileUpload: true });
    };

    onSelectFileUpload = (e, drop) => {
        e.preventDefault();
        let file = drop ? e.dataTransfer.files[0] : e.target.files[0];
        if (!file) return;
        let reader = new FileReader();
        this.setState({
            file: file,
            fileConvertError: null,
            uploadFileName: file.name,
        });
        reader.readAsDataURL(file);
        reader.onload = (res) => this.setState({ src: res.target.result });
    };

    uploadFile = async () => {
        const i = this.state.src.indexOf("base64,");
        let workbook = read(this.state.src.slice(i + 7), { type: "base64", cellDates: true });
        let worksheet = workbook.Sheets[workbook.SheetNames[0]];
        let wsData = utils.sheet_to_json(worksheet);
        let data = wsData.map(row => {
            let { Date, JobName, EINName, Hours } = row;
            return {
                company: this.props.UserReducer.companyId,
                date: Date.parse(startOfDay(Date)),
                jobName: JobName,
                EINName,
                hours: Hours
            }
        });

        let rowData = this.state.rowData;
        let uploadedDates = data.map(el => el.date);
        let override = rowData.filter(el => {
            let exists = uploadedDates.includes(el.date);
            return !exists;
        });
        let contractHoursData = sortBy([...override, ...data], ["date", "jobName"]);
        this.saveRecords(contractHoursData);
        this.setState({
            src: null,
            uploadFileName: "",
            showFileUpload: false,
            rowData: contractHoursData
        }, () => {
            let index = this.state.rowData.length - 1;
            this.gridApi.ensureIndexVisible(index, "bottom");
        });
    };

    LoadMoreComponent = () => {
        return (
            <>
                <div className="action">
                    <a role='button' className="link-primary" onClick={this.loadMore} aria-disabled={this.state.rowData && this.state.rowData.length >= 9999} >Load More...</a>
                </div>
            </>
        )
    };


    getAllData = async (startDate, endDate) => {
        let { company, companyId } = this.props.UserReducer;
        await this.getContractHrs({ startDate, endDate });
        await this.props.getAdminSettings(company);
        let { jobCCIndex, jobCCLevel } = this.props.PPD_ADMIN_SETTINGS_GET;
        await this.props.getChildCCByTreeIndex({ companyShortName: company, treeIndex: jobCCIndex, levelQuery: jobCCLevel });
        await this.props.GetEins(companyId);
    };

    async componentDidMount() {
        let endDate = Date.now()
        let startDate = Date.parse(subMonths(endDate, 1));
        let isMultiEIN = has(this.props.ClientDataReducer, "isMultiEIN") ? this.props.ClientDataReducer.isMultiEIN : this.props.UserReducer.companyDetails.isMultiEIN;
        await this.getAllData(startDate, endDate);
        let contractHoursData = (this.props.PPD_CONTRACT_HOURS.map(el => ({ ...el })) || []);
        contractHoursData.push({ date: startOfDay(new Date()) });
        let columnDefs = [{
            headerName: "Date",
            field: "date",
            editable: params => !params.node.rowPinned,
            singleClickEdit: props => !props.value,
            cellEditor: 'agDateCellEditor',
            isFullWidthRow: params => params.node.rowPinned,
            width: 100,
            valueFormatter: params => new Date(params.value).toLocaleDateString(),
            cellRendererSelector: (params) => {
                if (params.node.rowPinned) {
                    return {
                        component: this.LoadMoreComponent
                    };
                }
            }
        },
        {
            headerName: "Job Name",
            field: "jobName",
            editable: params => !params.node.rowPinned,
            singleClickEdit: props => !props.value,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorPopup: false,
            cellEditorParams: {
                values: this.props.CHILD_COST_CENTERS.map(job => job.name),
                searchType: "matchAny",
                allowTyping: true,
                filterList: true,
                highlightMatch: true,
                valueListMaxHeight: 200,
            }
        }];
        let einList = [];
        if (isMultiEIN) {
            columnDefs.push({
                headerName: "Facility",
                field: "EINName",
                editable: params => !params.node.rowPinned,
                cellEditor: "agRichSelectCellEditor",
                cellEditorPopup: false,
                cellEditorParams: {
                    values: this.props.EINS.records.map(ein => ein.companyEIN),
                    searchType: "matchAny",
                    allowTyping: true,
                    filterList: true,
                    highlightMatch: true,
                    valueListMaxHeight: 200,
                },
                singleClickEdit: props => !props.value
            });
        };
        columnDefs.push({
            headerName: "Hours",
            field: "hours",
            editable: params => !params.node.rowPinned,
            cellEditor: "agNumberCellEditor",
            cellEditorParams: {
                precision: 2,
                min: 0,
            },
            singleClickEdit: props => !props.value
        });
        this.setState({ startDate, endDate, isMultiEIN, einList, columnDefs, rowData: contractHoursData });
    };

    render() {
        const { rowData, columnDefs, showFileUpload, pinnedTopRowData } = this.state;
        return (
            <div>
                <div className="route_page rate_setup_page location-wage">
                    <div className="rates_list">
                        <h4 className="heading_h4">Contract Hours</h4>
                        <div className="list">
                            <Grid
                                rowData={rowData}
                                columnDefs={columnDefs}
                                height="650px"
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChange}
                                onFirstDataRendered={this.onFirstDataRender}
                                pinnedTopRowData={pinnedTopRowData}
                                showStatusBar={true}
                            >
                            </Grid>
                            {showFileUpload ?
                                <FileUpload
                                    HtmlFor="upld_cntrct_hrs_file"
                                    CAPTION="UPLOAD CONTRACT HOURS"
                                    FileError={this.state.fileConvertError}
                                    OnSelectFile={this.onSelectFileUpload}
                                    UploadFile={this.uploadFile}
                                    Color="#006874"
                                    Accept=".csv,.xls,.xlsx"
                                    ButtonText="Import Records"
                                /> :
                                <div onClick={this.addContractRecs} className="df acsa add_rate">
                                    <img src={Plus_icon} />
                                    <p>Upload Records</p>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = ({ UserReducer, PPDReducer, EINReducer, ClientDataReducer, CostCenterReducer }) => {
    let { PPD_CONTRACT_HOURS, PPD_ADMIN_SETTINGS_GET } = PPDReducer;
    let { EINS } = EINReducer;
    let { CHILD_COST_CENTERS } = CostCenterReducer;
    return { UserReducer, PPD_CONTRACT_HOURS, EINS, ClientDataReducer, CHILD_COST_CENTERS, PPD_ADMIN_SETTINGS_GET };
};
export default connect(mapStateToProps, {
    getContractHours,
    saveContractHours,
    GetEins,
    getChildCCByTreeIndex,
    getAdminSettings
})(PPDContHoursView);
